import { render } from "./Home.vue?vue&type=template&id=3ffdb983&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=3ffdb983&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffdb983"]])

export default __exports__